import { Controller } from "@hotwired/stimulus"

// Underline tabs. Every panel is in the page, so a tab can be reached by its #hash, and the
// selection survives a Turbo Stream replacing the tabs or a panel (the controller element is
// outside what gets replaced).
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { default: String }

  connect() {
    this.current = this.fromHash() || this.defaultValue || this.tabTargets[0]?.dataset.tab
    this.onHashChange = () => {
      const tab = this.fromHash()
      if (tab) this.select(tab)
    }
    window.addEventListener("hashchange", this.onHashChange)
    this.render()
  }

  disconnect() {
    window.removeEventListener("hashchange", this.onHashChange)
  }

  tabTargetConnected() { this.render() }
  panelTargetConnected() { this.render() }

  switch(event) {
    const tab = event.currentTarget.dataset.tab
    this.select(tab)
    history.replaceState(history.state, "", `#${tab}`)
  }

  select(tab) {
    this.current = tab
    this.render()
  }

  fromHash() {
    const hash = window.location.hash.slice(1)
    return this.tabTargets.some(tab => tab.dataset.tab === hash) ? hash : null
  }

  render() {
    if (!this.current) return

    this.tabTargets.forEach(tab => {
      tab.setAttribute("aria-selected", tab.dataset.tab === this.current ? "true" : "false")
    })
    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.tab !== this.current)
    })
  }
}
